var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "800px",
    height: "800px",
    viewBox: "-2 -3.5 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin",
    className: "jam jam-amazon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.829 4.741c-.484.038-1.043.075-1.601.15-.856.111-1.712.261-2.42.596C6.432 6.047 5.5 7.239 5.5 8.993c0 2.2 1.415 3.317 3.202 3.317.596 0 1.08-.073 1.526-.185.708-.224 1.303-.634 2.01-1.38.41.56.52.821 1.229 1.417.186.075.372.075.52-.037a66.533 66.533 0 0 0 1.64-1.417c.185-.15.147-.373.036-.56-.41-.522-.819-.97-.819-1.975V4.816c0-1.418.11-2.722-.93-3.69C13.057.34 11.716.042 10.675.042h-.447C8.329.155 6.319.975 5.872 3.324c-.074.298.15.41.299.449l2.084.26c.223-.038.334-.224.371-.41.187-.82.857-1.23 1.602-1.305h.15c.445 0 .929.187 1.19.558.297.448.26 1.045.26 1.567v.298zm0 2.164c0 .858.036 1.529-.41 2.273-.26.522-.707.858-1.191.97-.074 0-.185.038-.298.038-.818 0-1.303-.633-1.303-1.566 0-1.193.708-1.753 1.6-2.014.485-.112 1.044-.15 1.602-.15v.45zM18.686 15.765c.91-.77 1.294-2.167 1.314-2.897v-.122a.66.66 0 0 0-.08-.344c-.182-.222-1.518-.426-2.67-.081a3.19 3.19 0 0 0-.87.425c-.202.143-.162.323.04.304.223-.041.506-.06.83-.102.708-.06 1.537-.08 1.74.183.281.343-.324 1.843-.588 2.492-.08.203.101.285.284.142z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.1 12.868c2.609 2.37 6.047 3.789 9.89 3.789 2.386 0 5.136-.67 7.26-1.945.284-.163.566-.346.828-.548.364-.262.041-.669-.323-.507-.161.06-.344.143-.505.203a19.487 19.487 0 0 1-7.038 1.338c-3.6 0-7.078-.993-9.89-2.634-.263-.141-.445.122-.222.304z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazon);
export default __webpack_public_path__ + "static/media/amazon.18cb9556b5f93a14465d8a637ded0075.svg";
export { ForwardRef as ReactComponent };